export const MAX_PHONE_DIGITS = 20; // Max amount of digits is 19 and one more "+" character (in total 20 - max limit that AWS accepts)

export const MAX_PASSWORD_STRENGTH = 4;